<template>
  <div v-if="showBanner" class="cookie-banner">
    <div class="cookie-banner__content">
      <p class="cookie-banner__text">
        We use cookies to enhance your browsing experience and analyze our traffic. 
        By clicking "OK", you consent to our use of cookies.
      </p>
      <button 
        class="cookie-banner__button" 
        @click="acceptCookies"
        type="button"
      >
        OK!
      </button>
    </div>
  </div>
</template>

<script>
import { setCookie } from '~/utils/cookies'
import { useCookie } from '#imports'

export default {
  name: 'CookieBanner',
  data() {
    return {
      showBanner: false, // Start hidden by default
      cookieName: 'cookie_consent_accepted'
    }
  },
  mounted() {
    this.checkCookieConsent()
  },
  methods: {
    checkCookieConsent() {
      console.log("checkCookieConsent")
      // Use basic useCookie to read the existing cookie
      const consentCookie = useCookie(this.cookieName)
      console.log("cookie value", consentCookie.value)

      // Only show banner if cookie is missing or not set to true
      if (consentCookie.value !== true) {
        this.showBanner = true;
      }
    },
    async acceptCookies() {
      await setCookie(this.cookieName, true, 365) // Set cookie for 1 year
      this.showBanner = false
    }
  }
}
console.log("CookieBanner mounted")
</script>

<style lang="scss" scoped>
.cookie-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  color: #000;
  z-index: 9999;
  padding: 1rem;
  box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
  border-top: 1px solid rgba(255, 255, 255, 0.2);

  &__content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      flex-direction: column;
      text-align: center;
      gap: 0.75rem;
    }
  }

  &__text {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.4;
    flex: 1;

    @media (max-width: 768px) {
      font-size: 0.85rem;
    }
  }

  &__button {
    background-color: var(--color-orange, #ff6b35);
    color: white;
    border: none;
    padding: 0.75rem 2rem;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s ease;
    white-space: nowrap;

    &:hover {
      background-color: var(--color-yellow, #ffa500);
    }

    &:focus {
      outline: 2px solid white;
      outline-offset: 2px;
    }

    @media (max-width: 768px) {
      padding: 0.6rem 1.5rem;
      font-size: 0.9rem;
    }
  }
}
</style>
